module.exports = __webpack_public_path__ + "img/23.7d39f32e.png";